var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMovedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4997 9.16927H16.6663C17.583 9.16927 18.333 8.41927 18.333 7.5026V5.0026C18.333 4.08594 17.583 3.33594 16.6663 3.33594H12.4997C11.583 3.33594 10.833 4.08594 10.833 5.0026V7.5026C10.833 8.41927 11.583 9.16927 12.4997 9.16927ZM16.6663 7.5026H12.4997V5.0026H16.6663V7.5026ZM16.6663 16.6693H12.4997C11.583 16.6693 10.833 15.9193 10.833 15.0026V12.5026C10.833 11.5859 11.583 10.8359 12.4997 10.8359H16.6663C17.583 10.8359 18.333 11.5859 18.333 12.5026V15.0026C18.333 15.9193 17.583 16.6693 16.6663 16.6693Z",
    fill: "#05A83B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.59375 11.3402L3.94131 13.3419L8.73595 7.82031",
    stroke: "#05A83B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovedIcon);
export default __webpack_public_path__ + "static/media/moved-icon.296899a79128347c9f3abff1a65d167f.svg";
export { ForwardRef as ReactComponent };